import React, { useCallback, useEffect, useState } from 'react';
import api from '../../services/api';
import HorizontalTimelineForm from './HorizontalTimelineForm'; 

const HorizontalTimelineManager = ({ sectionId }) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false); 
  const [editingItem, setEditingItem] = useState(null); 

  const fetchItems = useCallback(async () => {
    try {
      setLoading(true);
      const res = await api.get(`/jb-acesso-master-control-cms/sections/sections/${sectionId}`);
      setItems(res.data.data.items || []);
    } catch (err) {
      console.error("Erro ao carregar fases:", err);
    } finally {
      setLoading(false);
    }
  }, [sectionId]);

  useEffect(() => {
    if (sectionId) fetchItems();
  }, [sectionId, fetchItems]);

  const handleDelete = async (itemId) => {
    if (window.confirm("Tem certeza que deseja remover esta fase? O sistema reordenará as outras automaticamente.")) {
      try {
        setLoading(true);
        // Chama a rota de delete criada no backend
        await api.delete(`/jb-acesso-master-control-cms/sections/timeline-items/${itemId}`);
        
        // Se deu sucesso, recarrega a lista para mostrar a nova ordem
        fetchItems(); 
      } catch (err) {
        console.error("Erro ao deletar fase:", err);
        alert("Erro ao deletar fase.");
        setLoading(false);
      }
    }
  };

  // SE O FORMULÁRIO ESTIVER ATIVO, RENDERIZA SÓ ELE
  if (showForm) {
    return (
      <HorizontalTimelineForm
        sectionId={sectionId} 
        itemToEdit={editingItem}
        onSuccess={() => {
          setShowForm(false);   // Volta pra lista
          setEditingItem(null); // Limpa ao fechar
          fetchItems();         // Atualiza a lista com o novo item
        }} 
        onCancel={() => {
            setShowForm(false);
            setEditingItem(null); // Limpa ao cancelar
        }}
      />
    );
  }

  // SE NÃO, RENDERIZA A LISTA NORMALMENTE
  if (loading) return <div className="text-center p-3">Carregando fases...</div>;

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h6 className="fw-bold mb-0">Fases Cadastradas</h6>
        <button className="btn btn-sm btn-success" onClick={() => setShowForm(true)}>
          <i className="bi bi-plus-lg me-1"></i> Nova Fase
        </button>
      </div>

      <div className="list-group">
        {items.length === 0 ? (
          <div className="list-group-item text-center text-muted py-4">
            Nenhuma fase cadastrada para esta obra.
          </div>
        ) : (
          items.sort((a, b) => a.item_order - b.item_order).map(item => (
            <div key={item.id} className="list-group-item list-group-item-action d-flex justify-content-between align-items-center">
              <div>
                <span className="badge bg-dark me-2">Fase {item.item_order}</span>
                <strong>{item.title}</strong>
                <span className="ms-2 text-primary small">{item.progress_percentage}%</span>
              </div>
              <div className="btn-group">
                <button 
                    className="btn btn-sm btn-outline-primary" 
                    title="Editar"
                    onClick={() => {
                        setEditingItem(item);  // Define quem vai ser editado
                        setShowForm(true);     // Abre a tela do form
                    }}>
                    <i className="bi bi-pencil"></i>
                </button>
                <button className="btn btn-sm btn-outline-danger" onClick={() => handleDelete(item.id)} title="Excluir">
                  <i className="bi bi-trash"></i>
                </button>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default HorizontalTimelineManager;
